import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { v4 as uuidv4 } from 'uuid';
import { useClientFields } from '../../../../sic-lib/api/hooks/useClientFields';
import { ViewProperty } from '../../../../sic-lib/types/ViewProperty';
import { hasMatchingFieldId } from '../../../../sic-lib/utils/functionalFilters';
import {
    mapToListOfFieldLabels,
    mapViewPropertiesToField,
} from '../../../../sic-lib/utils/functionalMappers';
import TableHeaderCheckbox from '../TableHeaderCheckbox/TableHeaderCheckbox';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: 'inherit',
        //backgroundColor: theme.palette.backgroundMainLayout.light
    },
    gridItemPrimary: {
        padding: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.divider}`,
        [theme.breakpoints.up(0)]: {
            flexBasis: 0,
            flexGrow: 1,
            flexShrink: 0,
        },
        [theme.breakpoints.up('md')]: {
            flexBasis: '320px',
            flexGrow: 0,
            maxWidth: '320px',
        },
    },
    gridItemSecondary: {
        flexBasis: '240px',
        flexGrow: 1,
        flexShrink: 0,
        width: '0px',
        padding: '18px',
        overflow: 'hidden',
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
}));

interface Props {
    columnTemplate: ViewProperty[];
    hasMediumScreen: boolean;
}

export default function ContactsTableHeader({ columnTemplate, hasMediumScreen }: Props) {
    const { classes } = useStyles();

    const { data: clientFields } = useClientFields();

    const [columnHeaders, setColumnHeaders] = React.useState<string[]>([]);

    React.useEffect(() => {
        const labeledProps = columnTemplate.map(itm =>
            mapViewPropertiesToField(clientFields?.filter(hasMatchingFieldId(itm.fieldId))[0])(itm),
        );

        const headers = labeledProps.map(mapToListOfFieldLabels);

        setColumnHeaders(headers);
    }, [columnTemplate, clientFields]);

    return (
        <Grid container direction="row" wrap="nowrap" alignItems="center" className={classes.root}>
            <Grid item className={classes.gridItemPrimary}>
                <Grid container direction="row" wrap="nowrap" alignItems="center" spacing={2}>
                    <Grid item>
                        <TableHeaderCheckbox />
                    </Grid>
                    <Grid item>
                        <Typography variant="subtitle2">Contact</Typography>
                    </Grid>
                </Grid>
            </Grid>
            {hasMediumScreen &&
                columnHeaders.map(lbl => (
                    <Grid key={uuidv4()} item className={classes.gridItemSecondary}>
                        <Typography variant="subtitle2">{lbl}</Typography>
                    </Grid>
                ))}
        </Grid>
    );
}
